import React, { useEffect } from 'react';
import { Navigate, isRouteErrorResponse, useRouteError } from 'react-router';
import * as Sentry from '@sentry/react';
import { ErrorFallback } from '@/components/ErrorFallback';
import { ROUTE_HOME } from '@/router/routes';

const NOT_FOUND_STATUS = 404;

export const RouteError: React.FC = () => {
  const error = useRouteError();
  const isNotFound =
    isRouteErrorResponse(error) && error.status === NOT_FOUND_STATUS;

  useEffect(() => {
    if (isNotFound) {
      return;
    }

    Sentry.captureException(error);
  }, [error, isNotFound]);

  if (isNotFound) {
    return <Navigate to={ROUTE_HOME} replace />;
  }

  return <ErrorFallback resetError={() => window.location.reload()} />;
};
